import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

const NAMESPACE = 'mya.profile';
const NAMESPACE_LOGIN = 'login';

/* istanbul ignore next */
const nameSelector = createSelector(
  (loginState = {}) => loginState.primaryContact || {},
  (primaryContact) => primaryContact.name || {}
);

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps: function (state) {
    let loginState = state[NAMESPACE_LOGIN];
    let name = nameSelector(loginState);

    return {
      firstName: name.firstName,
      lastName: name.lastName,
    };
  },
});

export default controller;
